<vd-dialog
  [title]="isDenied ? 'Réactiver les notifications iOS' : 'Activer les notifications sur iOS'"
  [subtitle]="isDenied
    ? 'Safari iOS ne redemande pas la permission une fois refusée. Suivez ces étapes.'
    : 'Sur iOS, la permission s\'active depuis Réglages.'"
  icon="notifications_active"
  tone="info"
  size="md"
  (closed)="close()"
>
  <div class="ios-guide-content">

    <!-- Banner explicatif -->
    <div class="ios-guide-banner" *ngIf="isDenied">
      <span class="material-icons-outlined">info</span>
      <div>
        <strong>Limitation Safari iOS</strong>
        <p>
          Une fois la permission refusée, le prompt natif ne réapparaît plus.
          Vous devez la réactiver manuellement dans Réglages iOS — c'est rapide :
          <strong>4 étapes ci-dessous</strong>.
        </p>
      </div>
    </div>

    <div class="ios-guide-banner alt" *ngIf="requiresInstall">
      <span class="material-icons-outlined">install_mobile</span>
      <div>
        <strong>PWA non installée</strong>
        <p>
          Sur iOS, les notifications push ne fonctionnent QUE depuis la PWA installée
          sur l'écran d'accueil. Ouvrez Safari → bouton Partage → « Sur l'écran d'accueil ».
        </p>
      </div>
    </div>

    <!-- Étapes -->
    <ol class="ios-steps">
      <li class="ios-step">
        <span class="ios-step-num">1</span>
        <div class="ios-step-body">
          <strong>Ouvrez les Réglages iOS</strong>
          <p>L'application <em>Réglages</em> (icône grise avec engrenages) sur votre écran d'accueil.</p>
        </div>
        <span class="ios-step-emoji">⚙️</span>
      </li>

      <li class="ios-step">
        <span class="ios-step-num">2</span>
        <div class="ios-step-body">
          <strong>Trouvez « {{ appName }} »</strong>
          <p>Faites défiler la liste des apps installées (en bas) ou utilisez la barre de recherche en haut.</p>
        </div>
        <span class="ios-step-emoji">🔍</span>
      </li>

      <li class="ios-step">
        <span class="ios-step-num">3</span>
        <div class="ios-step-body">
          <strong>Appuyez sur « Notifications »</strong>
          <p>Premier sous-menu de la page de l'app.</p>
        </div>
        <span class="ios-step-emoji">🔔</span>
      </li>

      <li class="ios-step">
        <span class="ios-step-num">4</span>
        <div class="ios-step-body">
          <strong>Activez « Autoriser les notifications »</strong>
          <p>Basculez le switch principal sur ON (vert). Choisissez ensuite le style d'affichage : Bannière + Centre de notifications + Écran verrouillé.</p>
        </div>
        <span class="ios-step-emoji">✅</span>
      </li>

      <li class="ios-step">
        <span class="ios-step-num">5</span>
        <div class="ios-step-body">
          <strong>Revenez dans {{ appName }}</strong>
          <p>Réouvrez l'app, ouvrez à nouveau cette page, et cliquez sur « Activer sur ce device » — vous serez désormais abonné aux push.</p>
        </div>
        <span class="ios-step-emoji">↩️</span>
      </li>
    </ol>

    <!-- Bonus : Background Sync info -->
    <div class="ios-guide-note">
      <span class="material-icons-outlined">info_outline</span>
      <p>
        <strong>Bon à savoir :</strong> Background Sync et Periodic Sync sont
        affichés <em>« Non supporté »</em> sur iOS — c'est <strong>normal</strong>, Apple ne supporte
        pas ces APIs. Vos commandes hors-ligne seront tout de même rejouées au
        prochain démarrage de l'app.
      </p>
    </div>

  </div>

  <div vd-dialog-actions>
    <vd-button variant="ghost" (click)="close()">Plus tard</vd-button>
    <vd-button variant="primary" (click)="tryOpenSettings()">
      <span slot="leading" class="material-icons-outlined">settings</span>
      Essayer d'ouvrir Réglages
    </vd-button>
  </div>
</vd-dialog>
